import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { MasterCard } from '../services/payment-method.model';

export class MasterpassCardDeleteAction implements Action {
  constructor(
    public onDeleteSuccess: (cardName: string) => any,
    public card: MasterCard,
    public msisdn: string
  ) {}
}



// WEBPACK FOOTER //
// src/app/buy/masterpass-card-delete-dialog/masterpass-card-delete-dialog.action.ts